import { keepPreviousData } from "@tanstack/react-query";

import type { SearchPatientsParams } from "@elation/api-client/src/stitch-web";
import { useSearchPatients } from "@elation/api-client/src/stitch-web";

import { getHttpStatus } from "@src/shared/utils/http/errors";

export const PATIENTS_PAGE_SIZE = 10;

export function usePatientsSearchQuery(
  params: SearchPatientsParams,
  options?: { query?: { enabled?: boolean } },
) {
  return useSearchPatients(
    {
      limit: PATIENTS_PAGE_SIZE,
      ...params,
    },
    {
      ...options,
      query: {
        // Keep showing the previous page/search results while a debounced
        // query change or pagination fetch is in flight, instead of
        // flashing to the loading skeleton on every keystroke or page turn.
        placeholderData: keepPreviousData,
        ...options?.query,
        retry: (failureCount, err) => {
          const status = getHttpStatus(err);
          if (status != null && status >= 400 && status < 500) return false;
          return failureCount < 2;
        },
      },
    },
  );
}
